<template>
    <fullscreen-drawer :visible="visible" :title="title" closable @close="handleClose($event, true)">
        <i slot="header-button" class="fal fa-lg fa-chevron-left" @click="handleClose" />
        <edit-profile
            :is-page="false"
            :reset-display-mode="resetDisplayMode"
            :change-display-mode="changeDisplayMode"
            @display-mode-changed="handleDisplayModeChanged"
        />
    </fullscreen-drawer>
</template>

<script>
    import { ref } from 'vue-demi';
    import {
        SETTINGS_DISPLAY_MODES,
        SETTINGS_DISPLAY_MODE_DEFAULT,
        SETTINGS_DISPLAY_MODE_BRANDS
    } from '../../../../app-v2/constants/settings';
    import EditProfile from './EditProfile.vue';
    import FullscreenDrawer from '../../../../app-v2/components/library/FullscreenDrawer.vue';

    export default {
        components: {
            FullscreenDrawer,
            EditProfile
        },

        name: 'SettingsDrawer',

        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },

        setup(props, context) {
            const currentDisplayMode = ref(SETTINGS_DISPLAY_MODE_DEFAULT);
            const resetDisplayMode = ref(false);
            const changeDisplayMode = ref(false);
            const title = ref(SETTINGS_DISPLAY_MODES[SETTINGS_DISPLAY_MODE_DEFAULT]?.title);

            const handleClose = (e = null, force = false) => {
                if (force || currentDisplayMode.value === SETTINGS_DISPLAY_MODE_DEFAULT) {
                    resetDisplayMode.value = true;
                    context.emit('close');
                } else if (currentDisplayMode.value === SETTINGS_DISPLAY_MODE_BRANDS) {
                    changeDisplayMode.value = SETTINGS_DISPLAY_MODE_DEFAULT;
                }
            };

            const handleDisplayModeChanged = (displayMode) => {
                title.value = SETTINGS_DISPLAY_MODES[displayMode]?.title;
                currentDisplayMode.value = displayMode;

                if (displayMode === SETTINGS_DISPLAY_MODE_DEFAULT) {
                    resetDisplayMode.value = false;
                    changeDisplayMode.value = false;
                }
            };

            return {
                title,
                resetDisplayMode,
                changeDisplayMode,
                handleDisplayModeChanged,
                handleClose
            };
        }
    };
</script>
